import { render, staticRenderFns } from "./GFileDoc.vue?vue&type=template&id=cb2331d2&"
import script from "./GFileDoc.vue?vue&type=script&lang=js&"
export * from "./GFileDoc.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports